import React from "react";
import logo from "../images/Modern_Stack_Systems_banner_black.png";

const MSS_URL = "https://modernstacksystems.com/";

const PoweredBy = ({ variant = "dark", className = "" }) => {
  const isLight = variant === "light";
  // Match the surrounding page background so the credit doesn't read as a separate band.
  // Dark variant lives on top of bg-gray-100 pages; light variant lives over a green
  // gradient/photo and should stay transparent.
  const containerBg = isLight ? "" : "bg-gray-100 border-t border-gray-200";
  const prefixText = isLight ? "text-white/80" : "text-gray-500";
  const taglineText = isLight ? "text-white/85" : "text-gray-900";
  const hoverText = isLight ? "hover:text-white" : "hover:text-gray-700";

  return (
    <div className={`flex justify-center py-6 px-4 ${containerBg} ${className}`}>
      <a
        href={MSS_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Powered by Modern Stack Systems - visit modernstacksystems.com"
        className={`group inline-flex flex-col items-center gap-2 transition-opacity duration-200 hover:opacity-90 ${prefixText} ${hoverText}`}
      >
        <div className="flex items-center gap-2.5 sm:gap-3">
          <span className="text-[11px] sm:text-xs font-medium uppercase tracking-wider">
            Powered by
          </span>
          <img
            src={logo}
            alt="Modern Stack Systems"
            className="h-10 sm:h-11 w-auto"
          />
        </div>
        <span className={`text-[11px] sm:text-xs font-medium ${taglineText}`}>
          Custom Software <span className="opacity-50 mx-0.5">•</span> Salesforce <span className="opacity-50 mx-0.5">•</span> AWS <span className="opacity-50 mx-0.5">•</span> AI
        </span>
      </a>
    </div>
  );
};

export default PoweredBy;
